import { useContext } from "react";
import OverlayContext from "@/components/overlays/OverlayContext";

/**
 * Hook to access the overlay system for opening / closing modals and drawers.
 *
 * @example
 * const { openModal, closeModal, openDrawer, closeDrawer } = useOverlay();
 *
 * openModal("LENDER_HEATMAP", ConneXLoansHeatMapModal, { lenderId }, { size: "MD" });
 * closeModal("LENDER_HEATMAP");
 *
 * openDrawer("CONNECTION_REQUEST", ProBulkConnectionRequestDrawer, { lenders }, { size: "XL" });
 * closeDrawer("CONNECTION_REQUEST");
 */
export function useOverlay() {
  const context = useContext(OverlayContext);

  if (!context) {
    throw new Error("useOverlay must be used within an OverlayProvider");
  }

  return context;
}
